// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1OWiU","fullView":"styles_fullView__24D4E"};